import { Typography } from "antd"

const { Title, Text } = Typography
const TabContentWrapper = ({ title, text, children }) => {
  return (
    <section style={{ padding: '20px 0 0 0' }}>
      <Title level={3}>{ title }</Title>
      <Text type="secondary">{text}</Text>
      <section style={{ padding: '20px 0 0 0' }}>
        {children}
      </section>
    </section>
  )
}

export default TabContentWrapper
